import _ from 'lodash';

import { IRoleScope, IUpdateMemberRolesParams } from './member-list.types';

interface IRoleGroupParams {
  roles: string[];
  groupRoles: string[];
  isLocked: (role: string) => boolean;
}

// A locked role is inherited from a higher level, so it counts as on without being stored.
export const areAllRolesOn = ({ roles, groupRoles, isLocked }: IRoleGroupParams) =>
  groupRoles.every(role => isLocked(role) || roles.includes(role));

// "All" only toggles the roles the row controls; a locked role keeps its stored state either way.
export const toggleAllRoles = ({ roles, groupRoles, isLocked }: IRoleGroupParams): string[] => {
  const controlled = groupRoles.filter(role => !isLocked(role));

  return areAllRolesOn({ roles, groupRoles, isLocked })
    ? _.difference(roles, controlled)
    : _.union(roles, controlled);
};

export const roleScopeOf = ({ member, ageGroupId, assessmentId }: IUpdateMemberRolesParams): IRoleScope => {
  if (ageGroupId) return { memberId: member._id, ageGroupId };
  if (assessmentId) return { memberId: member._id, assessmentId };
  return { memberId: member._id };
};

// One save in flight per stored role row.
export const roleScopeKey = ({ memberId, ageGroupId, assessmentId }: IRoleScope) =>
  [memberId, ageGroupId || '-', assessmentId || '-'].join(':');
